// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProfileSettings_profileSettingsContainer__53n5Q {
  padding: 1rem;
  max-width: 1200px;
  margin: auto;
}
.ProfileSettings_profileSettingsContainer__53n5Q .ProfileSettings_profileSettingsForm__CVwD8 .ProfileSettings_phoneInput__Kvi5n input {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/component/pages/staff/profile-settings/ProfileSettings.module.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,iBAAA;EACA,YAAA;AACJ;AAGY;EAAO,WAAA;AAAnB","sourcesContent":[".profileSettingsContainer{\n    padding: 1rem;\n    max-width: 1200px;\n    margin: auto;\n    \n    .profileSettingsForm{\n        .phoneInput {\n            input {width: 100%}\n          }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"profileSettingsContainer": `ProfileSettings_profileSettingsContainer__53n5Q`,
	"profileSettingsForm": `ProfileSettings_profileSettingsForm__CVwD8`,
	"phoneInput": `ProfileSettings_phoneInput__Kvi5n`
};
export default ___CSS_LOADER_EXPORT___;
